export const GRADING_RUBRIC = "grading-rubric";
export const STUDENT_SUMMARY = "student-summary";
export const CRITERIA_SUMMARY = "criteria-summary";
